import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { Tokens } from "Shared/Tokens";

const Errorpage = () => {
    const history = useHistory();
    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: Tokens.bg,
                color: Tokens.textPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px 16px",
            }}
        >
            <div
                style={{
                    maxWidth: "420px",
                    width: "100%",
                    backgroundColor: Tokens.card,
                    border: `1px solid ${Tokens.hairline}`,
                    borderRadius: Tokens.radiusCard,
                    padding: "24px",
                    textAlign: "center",
                }}
            >
                <div
                    style={{
                        fontSize: "18px",
                        fontWeight: 600,
                        color: Tokens.textPrimary,
                        marginBottom: "8px",
                    }}
                >
                    Page not found
                </div>
                <div
                    style={{
                        fontSize: "14px",
                        color: Tokens.textSecondary,
                        marginBottom: "20px",
                    }}
                >
                    Something went wrong or the page you requested does not
                    exist.
                </div>
                <Button
                    type="primary"
                    onClick={() => history && history.push("/")}
                    style={{
                        height: "40px",
                        borderRadius: Tokens.radiusControl,
                        fontWeight: 500,
                    }}
                >
                    Back to portfolios
                </Button>
            </div>
        </div>
    );
};

export default Errorpage;
